import "./App.css";
import Navabr from "./components/Navabr";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import WorkshopList from "./components/WorkshopListItems";
import Footer from "./components/Footer";
import SolutionListItems from "./components/SolutionListItems";
import ExperienceListItems from "./components/ExperienceListItems";
import SectionTitle from "./components/SectionTitle";
import TrainingListItems from "./components/TrainingListItems";
import ContactMe from "./components/ContactMe";
import { useRef } from "react";
import AwardsList from "./components/AwardsList";

function App() {
  // Create a reference for the contacts section
  const contactsRef = useRef(null);

  // Function to scroll to the contacts section
  const scrollToContacts = () => {
    contactsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <Navabr scrollToContacts={scrollToContacts} />{" "}
      {/* Pass the scroll function */}
      <section id="home">
        <HeroSection />
      </section>
      <section id="skills">
        <SectionTitle />
        <About />
      </section>
      <section id="projects">
        <div style={{ height: "20px" }}></div>
        <SolutionListItems />
      </section>
      <section id="experience">
        <div style={{ height: "20px" }}></div>
        <ExperienceListItems />
      </section>
      <section id="education">
        <div style={{ height: "20px" }}></div>
        <TrainingListItems />
        <AwardsList />
      </section>
      <section id="workshops">
        <div style={{ height: "20px" }}></div>
        <WorkshopList />
      </section>
      {/* Add the ContactMe section */}
      <section id="contacts" ref={contactsRef}>
        <SectionTitle />
        <ContactMe />
      </section>
      <div style={{ height: "48px" }}></div>
      <Footer />
    </div>
  );
}

export default App;
